import { render } from "./GroupsTable.vue?vue&type=template&id=310bc7a0&scoped=true"
import script from "./GroupsTable.vue?vue&type=script&lang=js"
export * from "./GroupsTable.vue?vue&type=script&lang=js"

import "./GroupsTable.vue?vue&type=style&index=0&id=310bc7a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310bc7a0"]])

export default __exports__